<div class="toast-region" aria-live="polite" aria-atomic="true">
  @for (notification of notificationService.notifications(); track notification.id) {
    <output class="app-toast app-toast--{{ notification.type }}">
      <div class="app-toast__content">
        <strong>{{ notification.title }}</strong>
        @if (notification.detail) {
          <span>{{ notification.detail }}</span>
        }
      </div>
      <button
        type="button"
        class="app-toast__close"
        [attr.aria-label]="text.closeLabel"
        (click)="notificationService.dismiss(notification.id)"
      >
        &times;
      </button>
    </output>
  }
</div>
